<template>
  <div id="Ticket">
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-4 top" v-if="ticket">
        <div class="return" @click="$router.push('/')">
          <font-awesome-icon class="icon ml-2" icon="arrow-left" />
        </div>
        <div class="language" @click="show_all_languages = !show_all_languages" v-if="Config.footer.language_selector">
          <div v-if="language == 'en'">
            <img src="/en.png" alt="" />
            <span>English</span>
            <font-awesome-icon class="icon ml-2" icon="caret-up" />
          </div>
          <div v-else-if="language == 'fr'">
            <img src="/fr.png" alt="" />
            <span>Français</span>
            <font-awesome-icon class="icon ml-2" icon="caret-up" />
          </div>
          <div v-else>
            <img src="/tn.png" alt="" />
            <span>العربية</span>
            <font-awesome-icon class="icon ml-2" icon="caret-up" />
          </div>
        </div>
        <div class="all_languages" v-show="Config.footer.language_selector && show_all_languages">
          <div @click="changeLanguage('en')">
            <img src="/en.png" alt="" />
            <span>English</span>
          </div>
          <div @click="changeLanguage('fr')">
            <img src="/fr.png" alt="" />
            <span>Français</span>
          </div>
          <div @click="changeLanguage('ar')">
            <img src="/tn.png" alt="" />
            <span style="letter-spacing: 0">العربية</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-4 content" v-if="ticket">
        <div class="backyard"></div>
        <div class="header">
          <div class="logo">
            <img v-if="!Config.vendor.custom_ticket_logo" :src="ticket.business_summary.photo" alt="" />
            <img v-else :src="Config.vendor.custom_ticket_logo_path" alt="" />
          </div>
          <div class="name">
            {{ ticket.business_summary.name }}
            <br />
            <p class="badge badge-secondary">
              {{ ticket.business_summary.address }},
              {{ ticket.business_summary.city }}
            </p>
          </div>
        </div>
        <div class="ticket">
          <div class="number">
            <span>{{
              $t("Components.Queue.TicketItem.ThanksForVisiting2")
            }}</span>
          </div>

          <div class="body">
            <div class="info">
              <div class="left">
                <b>{{ $t("Components.Queue.TicketItem.ThanksForVisitingThe") }}
                  {{ checkinTimeDateFormated }}</b>
              </div>
            </div>
            <div class="info">
              <div class="left mt-2">
                <b>{{ $t("ServicesPlural") }}</b>
              </div>
            </div>
            <div class="left mt-2">
              <div style="text-align: center">
                <p class="badge badge-secondary m-1" v-for="item in ticket.services" :key="item.id">
                  {{ item.title }}
                </p>
              </div>
            </div>
            <span class="info">
              <i @click="updateRating(index)" :class="rating >= index
                ? 'mdi mdi-star rating-star'
                : 'mdi mdi-star-outline rating-star'
                " :key="index + '-avg-full'" v-for="index in 5"></i>
            </span>
            <vs-textarea class="textarea-style" v-model="feedback_text" :placeholder="$t('Components.Queue.TicketItem.FeedbackTextPlaceholder')
              " />
            <vs-button class="w-50" style="background: #054479 !important; left: 25%" size="small" @click="openCaptcha">
              {{ $t("Components.Queue.TicketItem.FeedbackSubmitButton") }}
            </vs-button>
          </div>
        </div>

        <a :href="Config.ticket.ads.href" class="pub"
          v-if="Config.ticket.ads.status && Config.ticket.ads.type == 'image'">
          <img class="w-100" :src="Config.ticket.ads.url" alt="" />
        </a>
        <div class="copyright" v-if="Config.ticket.copyright.status">
          <div class="logo">
            <img :src="'/liberrex.png'" alt="Liberrex" :style="'height: ' +
              Config.ticket.copyright.logo.height +
              '; width: ' +
              Config.ticket.copyright.logo.width
              " />
          </div>
          <div class="text">
            <template v-if="$i18n.locale == 'en'">{{
              Config.ticket.copyright.text.en + $moment().format('YYYY')
            }}</template>
            <template v-else-if="$i18n.locale == 'fr'">{{
              Config.ticket.copyright.text.fr + $moment().format('YYYY')
            }}</template>
            <template v-else-if="$i18n.locale == 'ar'">{{
              Config.ticket.copyright.text.ar + $moment().format('YYYY')
            }}</template>
            <template v-else>{{ Config.ticket.copyright.text.fr + $moment().format('YYYY') }}</template>
          </div>
          <div class="url">
            <a :href="Config.ticket.copyright.link.href">{{
              Config.ticket.copyright.link.text
            }}</a>
          </div>
        </div>
      </div>
    </div>
    <CaptchaModal :active="captcha_modal.active" :errorCaptcha="captcha_modal.errorCaptcha"
      :styleCaptcha="captcha_modal.style" :titleCaptcha="captcha_modal.title" @confirm="ConfirmCaptcha"
      @cancel="CloseCaptcha" />
  </div>
</template>

<script>
import moment from "moment";
import $ from "jquery";
import CaptchaModal from "../modals/CaptchaModal.vue";
import { queueService, userService, advertisementService } from "../../_services";

export default {
  components: {
    CaptchaModal
  },
  data: () => ({
    servicesLength: false,
    ticket_uid: null,
    // ticket: null,
    is_running_late: 0,
    seconds_left: null,
    time_left: "--",
    time_left_interval: null,

    cancel_ticket_modal: {
      active: false,
      type: "danger",
    },
    late_modal: {
      active: false,
      type: "warning",
    },
    captcha_modal: {
      active: false,
      type: "",
      errorCaptcha: false,
      style: "",
      title: ""
    },
    position: {
      lat: 36,
      lng: 10,
    },
    position_is_correct: false,
    language: localStorage.getItem("Language"),
    show_all_languages: false,
    // *********************************************
    title: "TrackTicket",
    inServiceActive: false,
    inDelayedActive: false,
    inRunningLateActive: false,
    rating: 5,
    feedback_text: "",
    ticket: {
      id: 0,
      public_identifier: "",
      unique_id: "",
      checkinTime: "00:00:00",
      checkinDate: "0000-00-00",
      status: "",
      statusUpdateTimestamp: "",
      estimatedTimeToSpend: 0,
      counter_id: -1,
      customer_id: 0,
      services: [],
      service_names: "",
      business: 0,
      queue_line_id: 0,
      urgent: 0,
      tracked: 0,
      anonymous: 0,
      member_id: -1,
      waiting_time: 0,
      total_waiting: 0,
      business_summary: {
        id: 0,
        name: "",
        address: "",
        postal_code: "",
        phone: "",
        organization_id: "",
      },
      organization_summary: {},
    },
    advertisement: {},
    background_color: "",
    text_color: "",
    theme: "",
    ticketDisplay: "",
    adsActive: false,
    activeRating: false,
    test: true,
    showClose: false,
    video_link: "",
  }),

  methods: {
    ConfirmCaptcha(key, captcha) {
      this.captcha_modal.active = false;
      if (this.captcha_modal.type == 'feedback') {
        this.submitFeedback(key, captcha);
      }
    },
    CloseCaptcha() {
      this.captcha_modal.active = false;
      this.captcha_modal.type = "";
    },
    openCaptcha() {
      this.captcha_modal.active = true;
      this.captcha_modal.type = "feedback";
      this.captcha_modal.style = "primary";
      this.captcha_modal.title = this.$t('SubmitFeedback');
    },
    dropdownServices() {
      this.servicesLength = true;
    },
    hideServices() {
      this.servicesLength = false;
    },
    changeLanguage(language) {
      localStorage.setItem("Language", language);
      this.$router.go();
    },
    ConfirmLateModal() {
      this.late_modal.active = false;
      $("#PreLoader").show();
      let data = {
        queue_line_id: this.ticket.queue_line_id,
        ticket_id: this.ticket.id,
        rank: this.ticket.queue_rank,
      };
      queueService
        .moveToLast(data)
        .then(
          function () {
            this.is_running_late = true;
            this.initPage();
          }.bind(this)
        )
        .catch(function () {
          $("#PreLoader").hide();
        });
    },
    CloseLateModal() {
      this.late_modal.active = false;
    },
    ConfirmCancelTicket() {
      this.cancel_ticket_modal.active = false;
      $("#PreLoader").show();

      queueService
        .revokeTicketByUid(this.ticket_uid)
        .then(
          function () {
            location.replace("/");
          }.bind(this)
        )
        .finally(
          function () {
            $("#PreLoader").hide();
          }.bind(this)
        );
    },
    CloseCancelTicket() {
      this.cancel_ticket_modal.active = false;
    },
    initPage() {
      $("#PreLoader").show();
      this.ticket_uid = this.$route.params.uid;
      queueService
        .getArchivedTicketByUid(this.ticket_uid)
        .then(
          function (data) {
            if (data.ticket.rated == 1) {
              location.replace("/");
            }
            this.ticket = data.ticket;
            this.is_running_late = this.ticket.running_late;
            this.seconds_left = this.ticket.waiting_time;

            this.time_left_interval = setInterval(
              function () {
                if (this.seconds_left) {
                  let time_left_h = Math.floor(this.seconds_left / 3600);
                  let time_left_m = Math.floor((this.seconds_left % 3600) / 60);
                  let time_left_s = Math.floor((this.seconds_left % 3600) % 60);
                  if (time_left_h > 0) {
                    this.time_left = time_left_h + "h " + time_left_m + "m";
                  } else {
                    this.time_left = time_left_m + "m " + time_left_s + "s";
                  }
                  this.seconds_left--;
                } else {
                  this.time_left = "--";
                }
              }.bind(this),
              1000
            );
          }.bind(this)
        )
        .catch(function () {
          window.location.href = "/";
        })
        .finally(function () {
          $("#PreLoader").hide();
        });
    },
    // ***************************
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    showLoading() {
      this.$vs.loading({
        container: "#ticket-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#ticket-box > .con-vs-loading");
    },
    updateRating(r) {
      this.rating = r;
    },
    submitFeedback(key, captcha) {
      if (this.rating < 0) {
        this.activeRating = true;
      } else if (this.rating <= 3 && this.feedback_text.length < 4) {
        //alert("please be more specific");
      } else {
        $("#PreLoader").show();
        let payload = {
          uid: this.ticket_uid,
          rating: this.rating,
          feedback: this.feedback_text,
          anonymous: 0,
          key: key,
          captcha: captcha,
          _method: "PUT"
        };
        queueService
          .submitFeedbackByUid(payload)
          .then(
            function () {
              location.replace("/");
            }.bind(this)
          )
          .catch(
            function () {
              // location.replace("/");
              this.captcha_modal.active = true;
              this.captcha_modal.errorCaptcha = true;
            }.bind(this)
          )
          .finally(
            function () {
              $("#PreLoader").hide();
              this.activeRating = false;
            }.bind(this)
          );
      }
    },
    hideAd() {
      document.getElementById("image-ad").style.display = "none";
    },
  },
  computed: {
    checkinTimeDateFormated: function () {
      return this.$moment(
        this.ticket.checkinDate + " " + this.ticket.checkinTime
      ).format("DD MMM YYYY, HH:mm");
    },
    serviceTimeFormated: function () {
      return (
        this.$moment()
          .startOf("day")
          .add(this.ticket.estimatedTimeToSpend, "minutes")
          .format("HH") +
        "H" +
        this.$moment()
          .startOf("day")
          .add(this.ticket.estimatedTimeToSpend, "minutes")
          .format("mm")
      );
    },
    waitingTimeFormated: function () {
      return moment()
        .startOf("day")
        .add(this.ticket.waiting_time, "seconds")
        .format("HH:mm");
    },
    shouldBeThereAt: function () {
      return moment().add(this.ticket.waiting_time, "seconds").format("HH:mm");
    },
  },
  mounted() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          this.position.lat = position.coords.latitude;
          this.position.lng = position.coords.longitude;
          this.position_is_correct = true;
        }.bind(this)
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
    this.initPage();
  },
};
</script>

<style lang="scss">
.circle__value {
  color: var(--primary-font) !important;
}
</style>
<style lang="scss" scoped>
#Ticket {
  // height: 100vh !important;
  overflow-x: hidden !important;
  overflow-y: scroll !important;
  position: relative;

  .top {
    top: 0%;
    left: 50%;
    transform: translate(-50%, 0%);
    position: relative;
    width: 100%;
    text-align: right;
    padding: 10px 30px;
    background: var(--primary);
    z-index: 1;

    /* border-bottom: 1px solid #dfe4ea93; */
    .return {
      float: left;
      color: var(--primary-font);
      margin-top: 3px;
      cursor: pointer;
    }

    .language {
      cursor: pointer;

      img {
        height: 12px;
        width: 20px;
        margin-top: -5px;
        border-radius: 2px;
      }

      .icon {
        color: var(--primary-font);
      }

      span,
      a {
        font-size: 13px;
        padding-left: 10px;
        letter-spacing: 1px;
        color: var(--primary-font);
      }
    }

    .all_languages {
      position: absolute;
      z-index: 9999999999;
      top: 40px;
      right: 10px;
      // padding: 10px;
      box-shadow: 0 0 1px 1px #ccc;
      background: #fff;
      cursor: pointer;
      transition: 0.3s;
      text-align: left;

      // display: none;
      div {
        padding: 10px 15px;

        img {
          height: 12px;
          width: 20px;
          margin-top: -5px;
          border-radius: 2px;
        }

        span,
        a {
          font-size: 13px;
          padding-left: 10px;
          letter-spacing: 1px;
          color: #333;
        }
      }

      div:hover {
        background: var(--primary);

        span,
        a {
          color: var(--primary-font) !important;
        }
      }
    }
  }

  .loader {
    margin-top: 50%;
    margin-left: 50%;
    transform: translate(-50%, 0);

    img {
      width: 50px;
    }
  }

  .backyard {
    background: "#d4d1d4";
    border-radius: 0 0 10px 10px;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 65vh;
    z-index: -1;
  }

  .content {
    top: 0%;
    left: 50%;
    transform: translate(-50%, 0%);
    max-height: 100vh;
    width: 100%;
    // background: var(--primary);
    padding: 30px 0;

    // overflow-x: hidden !important;
    // overflow-y: scroll !important;
    .header {
      display: flex;
      justify-content: flex-start;
      z-index: 999;
      padding-left: 20px;

      .logo {
        width: 20%;

        img {
          padding-right: 10px;
          width: 75px;
          border-radius: 5px;
        }
      }

      .name {
        width: 100%;
        color: var(--primary-font);
        font-weight: bold;
        font-size: 17px;

        .badge {
          margin-top: 10px;
          border-radius: 100px;
          background: var(--secondary);
          color: var(--secondary-font);
          padding: 7px 15px;
        }
      }

      .circle {
        width: 75px;
        text-align: right;
        position: relative;

        img {
          width: 100%;
        }

        .count_down_value {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: var(--primary-font) !important;
          display: block;
          white-space: nowrap;
          margin-left: 5px;
        }

        .ready {
          font-weight: 900 !important;
          color: var(--secondary) !important;
          font-size: 15px;
          // white-space: normal;
          text-align: center;
          // border-top: 2px solid var(--secondary);
          /* border-bottom: 2px solid var(--secondary); */
          padding: 5px;
        }
      }
    }

    .ticket {
      z-index: 999;
      border-radius: 10px;
      margin-top: 30px;
      // -webkit-filter: drop-shadow(2px 5px 5px #888);
      // filter: drop-shadow(2px 5px 5px #888);
      // border: 1px solid var(--primary);
      box-shadow: 0 4px 2px -2px #c7ccd3;

      .number {
        padding: 25px 0 10px 0;
        text-align: center;
        font-size: 25px;
        font-weight: 900;
        color: var(--primary);
        border-radius: 80px 80px 0 0;
        background: #fff;
      }

      .divider {
        width: 100%;
        z-index: -1;
        margin-top: -15px;
        margin-bottom: -10px;

        .svg {
          width: 100%;
          // padding-right: 0.5px
        }
      }

      .body {
        border-radius: 0 0 10px 10px;
        background: #fff;
        padding: 0 20px 20px 20px;
        line-height: 1.5;

        .info {
          display: flex;
          justify-content: space-evenly;
          text-align: center;
          /* border-bottom: 2px solid #dfe4ea; */
          padding-bottom: 5px;
          padding-top: 5px;

          .left {
            width: 100%;
            /* border-right: 2px solid #dfe4ea; */
          }

          .right {
            width: 50%;
          }

          span {
            font-size: 15px;
            font-weight: 400;
            display: block;
            color: var(--special-font);
          }

          b {
            font-size: 20px;
            font-weight: 900;
            color: var(--primary);
            font-family: Arial, Helvetica, sans-serif !important;
          }
        }
      }

      .services {
        display: flex;
        justify-content: space-between;
        padding: 10px 0 20px 0;
        line-height: 2;

        .left {
          font-weight: bold;
          font-size: 17px;
          width: 40%;
          color: var(--special-font);
        }

        .right {
          text-align: right;
          width: 60%;

          span {
            color: var(--secondary);
            font-weight: bold;
            font-size: 17px;
            display: block;
          }
        }
      }

      .date_join {
        width: 100%;
        text-align: center;
        /* border-bottom: 2px solid #dfe4ea; */
        padding-bottom: 10px;

        small {
          color: var(--special-font);
          font-size: 12px;
        }

        span {
          display: block;
          color: #f7ad36;
        }
      }

      .footer {
        display: flex;
        justify-content: space-around;
        padding-top: 20px;

        .left {
          /* border-right: 2px solid #dfe4ea; */
          width: 50%;
          text-align: center;
          cursor: pointer;

          span {
            color: #f7ad36;
            font-weight: bold;
            display: block;
            font-size: 15px;
          }
        }

        .right {
          width: 50%;
          text-align: center;
          cursor: pointer;

          span {
            color: #e31d1a;
            font-weight: bold;
            display: block;
            font-size: 15px;
          }
        }
      }
    }

    .pub {}

    .copyright {
      text-align: center;
      font-size: 15px;
      padding-top: 20px;
      padding-bottom: 50px;
    }
  }
}

/* **************************************** */
.badge {
  margin-top: 10px;
  border-radius: 100px;
  background: var(--secondary);
  color: var(--secondary-font);
  padding: 7px 15px;
}

.download-app {
  max-width: 100%;
  padding: 10px;
  filter: grayscale(100%);
}

.download-app:hover {
  filter: grayscale(0%);
}

.business-info {
  align-items: center;
  justify-content: center;
}

.rating-star {
  color: gold;
  font-size: 46px;
}

.rating-star-small {
  color: gold;
  font-size: 24px;
}

.rating-average {
  font-size: 46px;
  color: lightgray;
}

.vs-avatar--con-img img {
  height: 100%;
}
</style>